const AnimalCount = ({ title, count, extra }) => {
  return (
    <div className={`border py-1 px-3 rounded-xl ${count > 0 && 'bg-theme-200'}`}>
      <div className="font-medium text-center">{title}</div>
      <div className="text-right font-medium">{count}</div>
    </div>
  );
};

export default AnimalCount;
